import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// user-client-mod -- LoginPage
//
// 登录页面，POST /api/auth/login
// - 用户名、密码
// - 客户端 fetch API 提交
// - 成功保存 token 并跳转用户中心，失败显示错误
import * as React from 'react';
export function LoginPage() {
    const [error, setError] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [hydrated, setHydrated] = React.useState(false);
    const [focusedField, setFocusedField] = React.useState(null);
    React.useEffect(() => {
        setHydrated(true);
    }, []);
    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        setError(undefined);
        const formData = new FormData(e.currentTarget);
        const username = formData.get('username').trim();
        const password = formData.get('password');
        if (!username || !password) {
            setError('请填写用户名和密码');
            return;
        }
        setLoading(true);
        try {
            const res = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ strategy: 'password', username, password }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                setError(data.error || `登录失败 (${res.status})`);
                return;
            }
            // 保存 token
            if (data.accessToken) {
                localStorage.setItem('accessToken', data.accessToken);
                if (data.refreshToken) {
                    localStorage.setItem('refreshToken', data.refreshToken);
                }
            }
            // 跳转到用户中心
            window.location.href = '/user-center';
        }
        catch (err) {
            setError(err.message || '登录请求失败，请稍后重试');
        }
        finally {
            setLoading(false);
        }
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("style", { children: `
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      ` }), _jsxs("div", { style: styles.bgDecoration, children: [_jsx("div", { style: { ...styles.bgCircle, ...styles.bgCircle1 } }), _jsx("div", { style: { ...styles.bgCircle, ...styles.bgCircle2 } }), _jsx("div", { style: { ...styles.bgCircle, ...styles.bgCircle3 } })] }), _jsxs("div", { style: styles.card, children: [_jsxs("div", { style: styles.cardHeader, children: [_jsx("div", { style: styles.logo, children: _jsxs("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", stroke: "white", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }), _jsx("circle", { cx: "12", cy: "7", r: "4" })] }) }), _jsx("h1", { style: styles.title, children: "\u6B22\u8FCE\u56DE\u6765" }), _jsx("p", { style: styles.subtitle, children: "\u767B\u5F55\u5230\u60A8\u7684\u8D26\u6237" })] }), error && (_jsxs("div", { style: styles.errorAlert, children: [_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "#dc2626", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("line", { x1: "15", y1: "9", x2: "9", y2: "15" }), _jsx("line", { x1: "9", y1: "9", x2: "15", y2: "15" })] }), _jsx("span", { children: error })] })), _jsxs("form", { onSubmit: handleSubmit, noValidate: true, style: styles.form, children: [_jsxs("div", { style: styles.fieldGroup, children: [_jsx("label", { htmlFor: "username", style: styles.label, children: "\u7528\u6237\u540D" }), _jsxs("div", { style: {
                                            ...styles.inputWrapper,
                                            ...(focusedField === 'username' ? styles.inputWrapperFocused : {}),
                                        }, children: [_jsxs("svg", { style: styles.inputIcon, width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }), _jsx("circle", { cx: "12", cy: "7", r: "4" })] }), _jsx("input", { id: "username", name: "username", type: "text", placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u540D", required: true, autoComplete: "username", style: styles.input, onFocus: () => setFocusedField('username'), onBlur: () => setFocusedField(null) })] })] }), _jsxs("div", { style: styles.fieldGroup, children: [_jsx("label", { htmlFor: "password", style: styles.label, children: "\u5BC6\u7801" }), _jsxs("div", { style: {
                                            ...styles.inputWrapper,
                                            ...(focusedField === 'password' ? styles.inputWrapperFocused : {}),
                                        }, children: [_jsxs("svg", { style: styles.inputIcon, width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }), _jsx("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })] }), _jsx("input", { id: "password", name: "password", type: "password", placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801", required: true, autoComplete: "current-password", style: styles.input, onFocus: () => setFocusedField('password'), onBlur: () => setFocusedField(null) })] })] }), _jsx("button", { type: "submit", disabled: loading, style: {
                                    ...styles.submitBtn,
                                    opacity: loading ? 0.7 : 1,
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }, children: loading ? (_jsxs("span", { style: styles.loadingText, children: [_jsx("span", { style: styles.spinner }), "\u767B\u5F55\u4E2D..."] })) : '登 录' })] }), _jsxs("div", { style: styles.footer, children: [_jsx("span", { style: styles.footerText, children: "\u8FD8\u6CA1\u6709\u8D26\u53F7\uFF1F" }), _jsx("a", { href: "/register", style: styles.link, children: "\u7ACB\u5373\u6CE8\u518C" })] })] }), !hydrated && _jsx("div", { style: styles.hydratingTip, children: "\u52A0\u8F7D\u4E2D..." })] }));
}
const styles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8fafc',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        position: 'relative',
        overflow: 'hidden',
        padding: '20px',
    },
    bgDecoration: {
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
    },
    bgCircle: {
        position: 'absolute',
        borderRadius: '50%',
        opacity: 0.08,
    },
    bgCircle1: {
        width: '600px',
        height: '600px',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        top: '-200px',
        right: '-150px',
    },
    bgCircle2: {
        width: '400px',
        height: '400px',
        background: 'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)',
        bottom: '-100px',
        left: '-100px',
    },
    bgCircle3: {
        width: '300px',
        height: '300px',
        background: 'linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%)',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    card: {
        width: '100%',
        maxWidth: '420px',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        padding: '40px 36px',
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 10px 40px -10px rgba(99,102,241,0.15)',
        position: 'relative',
        zIndex: 1,
    },
    cardHeader: {
        textAlign: 'center',
        marginBottom: '32px',
    },
    logo: {
        width: '56px',
        height: '56px',
        borderRadius: '16px',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
        boxShadow: '0 8px 20px -4px rgba(99,102,241,0.4)',
    },
    title: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#1e293b',
        margin: '0 0 6px 0',
        letterSpacing: '-0.02em',
    },
    subtitle: {
        fontSize: '14px',
        color: '#94a3b8',
        margin: 0,
    },
    errorAlert: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
        backgroundColor: '#fef2f2',
        borderRadius: '10px',
        border: '1px solid #fecaca',
        marginBottom: '20px',
        color: '#dc2626',
        fontSize: '14px',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    },
    label: {
        fontSize: '13px',
        fontWeight: 600,
        color: '#475569',
        letterSpacing: '0.01em',
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '0 14px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '2px solid #e2e8f0',
        transition: 'all 0.2s ease',
        height: '48px',
    },
    inputWrapperFocused: {
        borderColor: '#6366f1',
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 4px rgba(99,102,241,0.1)',
    },
    inputIcon: {
        color: '#94a3b8',
        flexShrink: 0,
        transition: 'color 0.2s ease',
    },
    input: {
        flex: 1,
        border: 'none',
        outline: 'none',
        fontSize: '14px',
        color: '#1e293b',
        backgroundColor: 'transparent',
        height: '100%',
    },
    submitBtn: {
        width: '100%',
        height: '48px',
        borderRadius: '12px',
        border: 'none',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: '#ffffff',
        fontSize: '15px',
        fontWeight: 600,
        letterSpacing: '0.05em',
        marginTop: '6px',
        transition: 'all 0.2s ease',
        boxShadow: '0 4px 14px -2px rgba(99,102,241,0.4)',
    },
    loadingText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
    },
    spinner: {
        width: '14px',
        height: '14px',
        border: '2px solid rgba(255,255,255,0.3)',
        borderTopColor: '#ffffff',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },
    footer: {
        textAlign: 'center',
        marginTop: '24px',
        paddingTop: '20px',
        borderTop: '1px solid #f1f5f9',
    },
    footerText: {
        fontSize: '14px',
        color: '#94a3b8',
    },
    link: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#6366f1',
        textDecoration: 'none',
        marginLeft: '4px',
        transition: 'color 0.2s ease',
    },
    hydratingTip: {
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#94a3b8',
    },
};
//# sourceMappingURL=login-page.js.map